import { render, staticRenderFns } from "./setting-products.vue?vue&type=template&id=2579b9ec&scoped=true"
import script from "./setting-products.vue?vue&type=script&lang=js"
export * from "./setting-products.vue?vue&type=script&lang=js"
import style0 from "./setting-products.vue?vue&type=style&index=0&id=2579b9ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2579b9ec",
  null
  
)

export default component.exports